import { useEffect } from 'react';

const ConsoleErrorSuppressor = () => {
  useEffect(() => {
    // Only suppress errors in production
    // if (process.env.NODE_ENV === 'production') {
      // Store original console methods
      const originalError = console.error;
      const originalWarn = console.warn;
      const originalLog = console.log;

              // List of error patterns to suppress
        const suppressPatterns = [
          // Third-party cookie errors
          'third-party cookie',
          'SameSite',
          'cookie',
          
          // Google Analytics/GTM errors
          'gtag',
          'googletagmanager',
          'analytics',
          '_ga',
          '_gid',
          'gtm',
          
          // Font loading errors (non-critical)
          'font',
          'Failed to load resource',
          'font-src',
          'data:application/font-woff',
          'contains an invalid source',
          
          // Service worker errors
          'service worker',
          'sw.js',
          
          // Common React warnings in production
          'Warning: ReactDOM.render is no longer supported',
          'Warning: componentWillMount',
          'Warning: componentWillReceiveProps',
          
          // Performance warnings
          'performance',
          'lighthouse',
          
          // Network errors that don't affect functionality
          'net::ERR_',
          'NetworkError',
          'net::ERR_BLOCKED_BY_CLIENT',
          
          // CORS errors from third-party scripts
          'CORS',
          'Cross-Origin',
          
          // Deprecated API warnings
          'deprecated',
          'legacy',
          
          // Facebook Pixel errors
          'facebook',
          'fbevents',
          '_fbp', 
          'connect.facebook.net',
          'fbevents.js',
          
          // CSP errors
          'Content Security Policy',
          'csp',
          'violates the following',
          'permissions policy violation',
          'payment is not allowed',
          
          // API 404 errors for missing endpoints
          'workout-profile',
          '404 (Not Found)',
          
          // Other common third-party errors
          'stripe',
          'paypal',
          'recaptcha'
        ];

      // Function to check if message should be suppressed
      const shouldSuppress = (message) => {
        const messageStr = String(message).toLowerCase();
        return suppressPatterns.some(pattern => 
          messageStr.includes(pattern.toLowerCase())
        );
      };

      // Override console.error
      console.error = (...args) => {
        const message = args.join(' ');
        if (!shouldSuppress(message)) {
          // originalError.apply(console, args);
        }
      };

      // Override console.warn
      console.warn = (...args) => {
        const message = args.join(' ');
        if (!shouldSuppress(message)) {
          // originalWarn.apply(console, args);
        }
      };

      // Override console.log for certain patterns
      console.log = (...args) => {
        const message = args.join(' ');
        // Only suppress logs that are clearly errors/warnings
        if (message.includes('ERROR') || message.includes('WARNING')) {
          if (!shouldSuppress(message)) {
            //  originalLog.apply(console, args);
          }
        } else {
          // Allow normal logs
          // originalLog.apply(console, args);
        }
      };

      // Suppress unhandled promise rejections from third-party scripts
      const originalUnhandledRejection = window.onunhandledrejection;
      window.onunhandledrejection = (event) => {
        const reason = event.reason;
        const message = reason?.message || reason?.toString() || '';
        
        if (shouldSuppress(message)) {
          event.preventDefault();
          return;
        }
        
        if (originalUnhandledRejection) {
          originalUnhandledRejection.call(window, event);
        }
      };

      // Suppress window errors from third-party scripts
      const originalErrorHandler = window.onerror;
      window.onerror = (message, source, lineno, colno, error) => {
        const messageStr = String(message);
        const sourceStr = String(source);
        
        // Suppress errors from third-party domains
        if (sourceStr.includes('googletagmanager.com') ||
            sourceStr.includes('google-analytics.com') ||
            sourceStr.includes('facebook.com') ||
            sourceStr.includes('connect.facebook.net') ||
            shouldSuppress(messageStr)) {
          return true; // Prevent default error handling
        }
        
        if (originalErrorHandler) {
          return originalErrorHandler.call(window, message, source, lineno, colno, error);
        }
        
        return false;
      };

      // Clean up function
      return () => {
        console.error = originalError;
        console.warn = originalWarn;
        console.log = originalLog;
        window.onunhandledrejection = originalUnhandledRejection;
        window.onerror = originalErrorHandler;
      };
    // }
  }, []);

  // Also prevent React DevTools warnings in production
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // Disable React DevTools
      if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot = () => {};
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount = () => {};
      }
    }
  }, []);

  return null; // This component doesn't render anything
};

export default ConsoleErrorSuppressor;